module.exports = __webpack_public_path__ + "img/contact-icon-01.38ea44f8.gif";